import $ from 'jquery'
import 'soundmanager2'
import { util } from '../service/util'

var temp = `<div class="g-player" style="bottom:170px">
                <div class="glp-normal show" style="transition: all 0.3s ease 0.5s; left: -670px">
                	<div class="glp-normal-left left">
                		<div class="g-play-btn-wrap left">
                			<a class="g-play-btn" href="javascript:;"></a>
                		</div>
	                	<div class="g-radio-voice left">
							<a class="g-radio-horn">
								<div class="g-volume">
								<div class="volume-progressbar">
									<div class="volume-seekbar" style="height: 100.00%"></div>
									<div class="volume-playbar" style="height: 80.00%"></div>
									<div class="volume-space"></div>
								</div>
							</div>
							</a>
	                	</div>
	                    <div class="left progress-bar">
	                        <marquee class="title g-player-info" scrollamount="2" onMouseOut="this.start()" onMouseOver="this.stop()">未加载</marquee>
	                        
	                        <span class="time sound_position">00:00</span>
	                        <div class="player_progressbar" title="点击播放">
	                            <div class="player_seekbar" style="width: 100%;"></div>
	                            <div class="player_playbar" style="width: 00.00%;"></div>
	                        </div>
	                        <span class="time sound_duration j-sound_durationStr">00:00</span>
	                    </div>
	                    <div class="g-player-down left">
	                    	<a href="javascript:;" target="_blank"></a>
	                    </div>
	                    <div class="g-player-share left">
	                    	<a href="javascript:;"></a>
	                    </div>
	                    <div class="g-player-shareBox" style="display:none">
          					<a class="item lf" onclick="javascript:bShare.share(event,'weixin');return false;" title="分享至微信">
                				<i class="share-ic ic-weixin"></i>
                				分享至微信
          					</a>
          					<a class="item lf" onclick="javascript:bShare.share(event,'sinaminiblog');return false;" title="分享至新浪微博">
				                <i class="share-ic ic-weibo bshare-sinaminiblog"></i>
				                分享至新浪微博
			                </a>
				            <a class="item lf" onclick="javascript:bShare.share(event,'qqim');return false;" title="分享至QQ好友">
				              <i class="share-ic ic-qq"></i>
				              分享至QQ好友
				            </a>
        				</div>
        				<div class="g-player-list"></div>
        				<div class="g-player-listBox" style="display:none">
        					<div class="title">播放列表<span class="icon_close">×</span></div>
        					<ul>
								
							</ul>
						</div>
                	</div>
                    <div class=" left gnormal-btn-more">
                    </div>
                </div>
                <!-- mini -->
                <div class="glp-mini show" style="transition: all 0.3s ease 0.5s; left: 0px"">
                    <div class="glp-panel">
                        <img class="sound_face" src="/static/player_bga.jpg">
                        <div class="g-masker"></div>
                        <i class="btn-player ic playBtn" title="播放"></i>
                    </div>
                    <div class="btn-more">
                        <i class="ic ic-arrow"></i>
                    </div>
                    <i class="icon-playing"></i>
                </div>
            </div>`;
var SERVER_PATH = util.getOSS(),
	IMG_PATH = util.imgPath('');
	// IMG_PATH    = 'http://192.168.0.56:8089/public/';
var API = util.api(['ADDPLAYCOUNT','ADDDOWNLOADCOUNT']);
var audio = null;
var prog_len = null,
	prog_hei = null;
var player = {
		init : function(){
			var t = {
				// 播放器容器
				wrap : $(".g-player"),
				// 播放按钮
				playBtn : $(".g-play-btn"),
				// 滚动信息
				info : $(".g-player-info"),
				// 当前时间
				curTime : $(".time.sound_position"),
				// 总时长
				totalTime : $(".j-sound_durationStr"),
				// 进度条
				progressBar : $(".player_playbar"),
				// mini
				mini : $(".glp-mini"),
				miniBtn : $(".btn-player"),
				// normal
				normal : $(".glp-normal"),
				// 长度
				// 分享按钮
				shareBtn : $(".g-player-share"),
				// 分享盒子
				shareBox : $(".g-player-shareBox"),
				// 列表按钮
				listBtn : $(".g-player-list"),
				// 列表容器
				listWrap: $(".g-player-listBox")
			}
			prog_len = $('.player_progressbar').width();
			prog_hei = $('.volume-progressbar').height();
			$.extend(this, t);
		}
	}
// reg
var gPlayer = {
	// 当前页面所有声音数据
	soundData  : {},
	// 记录已经播放
	played : {},
	// 播放中回调
	whileplaying : null,
	/**
	 * 播放列表数据
	 */
	playList: [],
	playListIds: [],
	initPlayer : function(soundData,withList){
		var jq = $('.sd-player');
		if(!jq.length){
			$('body').append('<div class="sd-player"></div>');
			jq = $('.sd-player');
			// throw new Error('未找到播放器标签，请在<body>中加入<div class="sd-player"></div>！！！！');
		}
		// 嵌入模版
		jq.css({'position':'absolute','z-index':999}).first().html(temp);
		player.init();
		// data 引用
		this.soundData = soundData;
		// 进度条点击事件
		$(".player_progressbar").click(function(e){
			if(!audio.url)
				return;

			var percent = e.offsetX / (prog_len + 2);
			var position = audio.duration * percent;
			audio.setPosition(position);
			if(audio.playState != 1 || audio.paused){
				gPlayer.gPlay();
			}
			// audio.paused && gPlayer.gPlay();
			// 更新页面
			updatePage();
		})
		// 音量
		$(".volume-progressbar").click(function(e){
			if(!audio.url)
				return;
			var percent = 1.0 - e.offsetY / prog_hei;
			var volume = 100 * percent;
			$('.volume-playbar').css('height', volume + '%');
			audio.setVolume(volume);
		})
		// 按钮
		$('.btn-player,.g-play-btn').click(function(){
			// 未加载音频
			if(!audio.url){
				return;
			}
			if(audio.playState === 0 || audio.paused === true){
				gPlayer.gPlay();
			} else {
				gPlayer.gPause();
			}
			// 更新页面
			updatePage();
		})
		// 分享
		player.shareBtn.find('a').click(function(){
			if(player.shareBtn.hasClass('onclick')){
				player.shareBtn.removeClass('onclick');
				player.shareBox.hide();
			} else {
				player.shareBtn.addClass('onclick');
				player.shareBox.show();
			}
		})
		var play_n = $(".glp-normal"),
			play_m = $(".glp-mini");
		// 收起
		$(".gnormal-btn-more").click(function(e){
			play_n.attr('style', 'transition: all 0.5s ease 0.0s; left: -670px;');
			play_m.attr('style', 'transition: all 0.5s ease 0.5s; left: 0px;');
			// 隐藏分享
			player.shareBtn.removeClass('onclick');
			player.shareBox.hide();
			player.listWrap.hide();
		})
		// 展开
		$(".btn-more").click(function(e){
			play_n.attr('style', 'transition: all 0.5s ease 0.5s; left: 0px;');
			play_m.attr('style', 'transition: all 0.5s ease 0.0s; left: -170px;');
		})
		// 离开播放器隐藏分享按钮
		$(".glp-normal").mouseleave(function(){
			player.shareBtn.removeClass('onclick');
			player.shareBox.hide();
		})
		// 下载count增加
		$(".g-player-down").click(function(){
			if(audio.id.substr(0,1) != 'c' && audio.url)
				util.kAjax(API.ADDDOWNLOADCOUNT,{id:audio.id});
		})
		// 列表切换
		$('.icon_close').click(function(){
			player.listWrap.hide();
		})
		player.listBtn.click(function(){
			player.listWrap.toggle();
			// 更新正在播放的块的位置
			gPlayer.updateListPosition();
		})
		soundManager.setup({
	 		useHighPerformance: true,
	 		useConsole: false,
	 		debugMode : false,
	 		onready: function() {
	 			audio = soundManager.createSound({
				 	id: 'audio',
				 	volume : 80 ,
					// url: 'http://audio.xmcdn.com/group25/M0A/79/2B/wKgJMVierPnhGDg9AFHNopLM-pk962.m4a',
			 		whileloading: function() {
			 			// 加载时
			 			player.totalTime.text(formatMusicTime(audio.durationEstimate));
					},
			 		whileplaying: function() {
			 			// 更新进度
			 			updateProg();
					},
			 		onload: function() {
			 			// 总时长
			 			updateTotal();
					},
			 		onfinish: function() {
			 			var event;
			 			try {
							 event = new Event('click');
			 			} catch (ex) {
							 event = document.createEvent('MouseEvent');
							 event.initEvent('click', true, false);
						}
						audio.stop();
						updateProg();
						updatePage();
						/**
						 * 开启了列表播放
						 */
						if(gPlayer.playList.length){
							gPlayer.playNext();
							// 更新播放列表位置
							gPlayer.updateListPosition();
						}
					}
				})
				// 调试
				window.audio = audio;
			}
		});
		this.initStaticData();
	},
	// 初始化静态数据,并绑定播放事件
	initStaticData : function(){
		var doms = $('[sound-id]'),
			data = {};
		$.each(doms, function(i,d){
			var $this = $(this),
				id = $this.attr('sound-id');
			if(id){
				data[id] = {
					id    : $this.attr('sound-id'),
					audio : $this.attr('sound-url'),
					title : $this.attr('title'),
					img   : $this.attr('sound-img'),
					dubbingName:$this.attr('dubber-name'),
					dubbingId  :$this.attr('dubber-id')
				}
			}
		})
		// 移除地址属性
		doms.removeAttr('data-url');
		// 挂载播放代理
		$('body').on('click', '[sound-id] .sound-play', function(){
			gPlayer.gChange(this);
		})
		// 挂载下载代理
		$('body').on('click', '[sound-id] .sound-down', function(){
			gPlayer.gDownload(this);
		})
		// 仅添加下载次数
		$('body').on('click', '[sound-id] .sound-down-count', function(){
			gPlayer.gDownload(this,true);
		})
		$.extend(this.soundData,data,true);
	},
	isPlaying : function(){
		return audio.url && !audio.paused;
	},
	gPlay : function(){
		if(audio){
			audio.play();
		}
	},
	gPause : function(){
		if(audio){
			audio.pause();
		}
	},
	/**
	 * 列表播放
	 * el : 声音item子元素, 声音id
	 */
	listPlay: function(el){
		// 找到声音item集合
		var $el,
			$items,
			listData = [],
			listIds  = [],
			tId = '';
		if(typeof el == 'string' || typeof el == 'number'){
			$el = $('[sound-id='+el+']');
		} else {
			$el = $(el);
		}
		if($el.attr('sound-id')){
			$items = $el.parent().children();
			tId = $el.attr('sound-id');
		} else {
			$el = $el.parents('[sound-id]:first');
			tId = $el.attr('[sound-id]');

			$items = $el.parent().children();
		}
		$items.each((i,d) => {
			var id = $(d).attr('sound-id');
			if(!id){
				return true;
			}
			gPlayer.soundData[id].id = id;
			listIds.push(id+'');
			listData.push(gPlayer.soundData[id]);
		})
		gPlayer.playList = listData;
		gPlayer.playListIds = listIds;
		gPlayer.playIndex= $el.index();
		gPlayer.updateListView();
		// gPlayer.gChange(tId);
	},
	// 更新列表
	updateListView: function(){
		let temp = '';
		$.each(this.playList, (i,d) => {
			temp += `<li sound-id="${d.id}"><button class="sound-play"></button><a href="${d.dubbingId ? ('/n/'+d.dubbingId+'/'+d.id+'.html') : 'javascript:;'}" target="_blank" class="title_voice left">${d.title}</a> <a href="${d.dubbingId ? ('/n/'+d.dubbingId+'.html') : 'javascript:;'}" target="_blank" class="name_teacher right">${d.dubbingName||''}</a></li>`;
		})
		player.listWrap.find('ul').replace(temp);
	},
	// 更新正在播放的声音位于列表的位置
	updateListPosition: function(){
		let item = player.listWrap.find('[sound-id='+audio.id+']'),
			index= item.index(),
			y    = 54 * index - 120;
		player.listWrap.find('ul').animate({scrollTop:y},500);
	},
	// 下一个
	playNext: function(){
		let item = this.playList[this.playIndex+1];
		if(item){
			this.playIndex++;
			// 仅查找播放列表中的dom
			this.gChange(player.listWrap.find('[sound-id='+item.id+']:first'));
		} else {
			console.warn('未找到index='+(this.playIndex+1)+'的声音数据！');
		}
	},
	// 上一个
	playPre : function(){
		let item = this.playList[this.playIndex-1];
		if(item){
			this.playIndex--;
			// 仅查找播放列表中的dom
			this.gChange(player.listWrap.find('[sound-id='+item.id+']:first'));
		} else {
			console.warn('未找到index='+(this.playIndex-1)+'的声音数据！');
		}
	},
	/**
	 * 根据声音id切换声音
	 * - 声音信息必须先被缓存
	 */
	gChange : function(_id){
		gPlayer.listPlay(_id);
		// 如果是dom对象
		var id = _id;
		if(typeof _id == 'object'){
			// 本身带id
			var $jq = $(_id);
			id = $jq.attr('sound-id') || $jq.parents('[sound-id]:first').attr('sound-id');
			// var p = $(_id).parents('[sound-id]:first');
			// id = p.attr('sound-id');
		}
		var data = this.soundData[id];
		if(!data){
			console.log(this.soundData);
			console.log('error - 未找到声音id:'+id);
			return;
		}
		var _url = data.audio;;
		// 未改变歌曲
		if(audio.id && audio.id == id){
			// 已经停止
			if(!audio.playState){
				this.gPlay();
			// 正在播放
			} else if(!audio.paused){
				this.gPause();
			// 已经暂停
			} else {
				this.gPlay();
			}
			updatePage(id);
			return;
		}

		// 拼接(‘http://’开头为不拼接)
		_url = _url && _url.substr(0,4) == 'http' ? _url : SERVER_PATH + _url;
		// 地址无效
		if(!_url){
			return;
		}
		// 停止当前
		audio.stop();
		// 更新id
		audio.id = id;
		// 更新url
		audio.url = _url;
		// 播放
		gPlayer.gPlay();
		// 更新页面
		updatePage(id);
		if(!this.firstTry){
			this.firstTry = true;
			openPlayer();
		}
	},
	/**
	 * 根据sound-id下载对应声音
	 */
	gDownload : function(id,count){
		var _id = '';
		if(typeof id == 'object'){
			_id = $(id).itemId('sound-id');
		} else {
			_id = id;
		}
		// 从soundData中获取数据并下载
		var data = gPlayer.soundData[_id];
		if(data){
			if(!count){
				var isFox = (navigator.userAgent.toUpperCase().indexOf("FIREFOX") != -1);
				if(isFox){
					window.location = SERVER_PATH + data.audio;
				} else {
					var link = $('<a href="'+ SERVER_PATH + data.audio +'" download="down"></a>');
					link[0].click();
					if(typeof window.location == 'string'){
						window.location = SERVER_PATH + data.audio;
					}
				}
			}
			util.downCount(_id);
		}
	}
}

// 更新页面
function updatePage(id){
	var id = id || audio.id;
	var data = gPlayer.soundData[id],
		img  = data.img,
		title = data.title,
		t = $('.title.g-player-info');

	// 清空所有正在播放的状态
	$('.is-play').removeClass('is-play');
	var item = $('[sound-id='+audio.id+']');
	var paused = audio.paused;
	// 正在播放
	if(!paused && audio.playState){
		// 播放状态
		player.wrap.addClass('is-play');
		// 滚动信息
		title && title != t.text() && t.replaceWith('<marquee class="title g-player-info" scrollamount="2"  onMouseOut="this.start()" onMouseOver="this.stop()">'+title+'</marquee>');
		// mini播放器(区分本地图片)
		img && player.mini.find('.sound_face').attr('src', img.substr(0,4) == 'http' ? img : IMG_PATH + img);
		// img && player.mini.find('.sound_face').attr('src', img.substr(0,1) == '/' ? img : IMG_PATH + img);
		// 页面按钮
		item.addClass('is-play');
	// 已经暂停
	} else {
		// 播放状态
		player.wrap.removeClass('is-play');
		// 滚动信息
		title && title != t.text() && $('.title.g-player-info').replaceWith('<marquee class="title g-player-info" scrollamount="2"  onMouseOut="this.start()" onMouseOver="this.stop()">'+title+'</marquee>');
	}

	// 下载
	$('.g-player-down a').attr('href',audio.url).attr('download',title);
	// 增加播放数量（c开头id的为本地声音）
	if(!gPlayer.played[id] && id.substr(0,1) != 'c'){
		gPlayer.played[id] = true;
		util.kAjax(API.ADDPLAYCOUNT, {id:id});
	}
}

// 展开
function openPlayer(){
	$(".btn-more").click();
}
// 关闭
function closePlayer(){
	$(".gnormal-btn-more").click();
}
// 更新进度
function updateProg(){

	var percent = audio.position * 100 / audio.duration;
	player.curTime.text(formatMusicTime(audio.position));
	player.progressBar.css('width',percent + '%');

	// 执行回调
	typeof gPlayer.whileplaying == 'function' && gPlayer.whileplaying(percent,audio.id);
}

// 更新总时长
function updateTotal(){
	player.totalTime.text(formatMusicTime(audio.duration));
}

function formatMusicTime(milliseconds) {
	var hours = Math.floor(milliseconds / 3600000);
 	milliseconds = milliseconds % 3600000;
	var minutes = Math.floor(milliseconds / 60000);
	milliseconds = milliseconds % 60000;
	var seconds = Math.floor(milliseconds / 1000);
	milliseconds = Math.floor(milliseconds % 1000);

	return 	(minutes < 10 ? '0' : '') + minutes + ':' +
			(seconds < 10 ? '0' : '') + seconds;
}
window.gPlayer = gPlayer;
export {gPlayer};



// WEBPACK FOOTER //
// ./src/plug/playerController.js